// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Eigd","title":"Header_title__3EoIX","left":"Header_left__2TEBt","clinicName":"Header_clinicName__G3LSh"};